import { AVATAR_FALLBACK, CAL_URL } from "@calcom/lib/constants";
import type { Team } from "@calcom/prisma/client";

/**
 * Given an avatar URL, return it, or the local placeholder avatar if there is none.
 *
 * Upstream asked ui-avatars.com for a placeholder with the initials of the name, which sent the name and every
 * visitor's IP address to a third party (Miragon fork, see FORK_CHANGES.md).
 */
export function getPlaceholderAvatar(avatar: string | null | undefined, _name?: string | null) {
  return avatar ? avatar : CAL_URL + AVATAR_FALLBACK;
}

export function getOrgOrTeamAvatar(
  team: Pick<Team, "logoUrl" | "name"> & { parent?: Pick<Team, "logoUrl"> | null }
) {
  return getPlaceholderAvatar(team.logoUrl || team.parent?.logoUrl, team.name);
}
